export const HERO_BG =
  "https://readdy.ai/api/search-image?query=editorial%20collage%20about%20hot%20trending%20topics%20and%20keyword%20search%20archive%20warm%20vermilion%20and%20amber%20ink%20waves%20flowing%20across%20deep%20charcoal%20paper%20scattered%20small%20newspaper%20clippings%20and%20floating%20tag%20marks%20dramatic%20spotlight%20from%20the%20top%20cinematic%20film%20grain%20high%20contrast%20moody%20sophisticated%20art%20direction%20no%20text%20no%20faces&width=1800&height=900&seq=kanliao-hero-2026&orientation=landscape";

export const TRENDS = [
  { rank: 1, kw: "顶流官宣后续", cat: "人物", heat: "热度 98.6万", up: true, delta: "+12%" },
  { rank: 2, kw: "直播一哥深夜回应", cat: "事件", heat: "热度 91.2万", up: true, delta: "+9%" },
  { rank: 3, kw: "综艺恶意剪辑疑云", cat: "事件", heat: "热度 84.7万", up: false, delta: "-3%" },
  { rank: 4, kw: "新晋选秀咖塌房", cat: "人物", heat: "热度 78.9万", up: true, delta: "+21%" },
  { rank: 5, kw: "短剧女主合同纠纷", cat: "人物", heat: "热度 70.3万", up: false, delta: "-6%" },
  { rank: 6, kw: "带货翻车全记录", cat: "事件", heat: "热度 66.1万", up: true, delta: "+7%" },
  { rank: 7, kw: "年度十大争议盘点", cat: "专题", heat: "热度 59.4万", up: true, delta: "+15%" },
  { rank: 8, kw: "匿名爆料可信度", cat: "科普", heat: "热度 52.8万", up: false, delta: "-2%" },
];

export const RISING = [
  { kw: "聊天记录被扒", tag: "新瓜", heat: "今日 +1.8万" },
  { kw: "声纹真假难辨", tag: "技术向", heat: "今日 +1.2万" },
  { kw: "旧料重开时间线", tag: "复盘", heat: "今日 +0.9万" },
  { kw: "同款扒同款", tag: "考据", heat: "今日 +0.7万" },
];

export const CATALOG = [
  {
    key: "people",
    icon: "ri-user-search-line",
    title: "按人物找",
    lead: "输入艺人、主播、网红姓名或常用标签，一键锁定与该人物相关的话题档案、争议整理与时间线。",
    tip: "试：选秀咖 · 带货一哥 · 综艺咖",
    chips: ["姓名标签", "代表作品", "圈内人设", "关联瓜点"],
  },
  {
    key: "event",
    icon: "ri-question-answer-line",
    title: "按事件找",
    lead: "围绕一次爆料、一场风波或一档节目的争议，按事件名直接检索，目录把前因后果归档得清清楚楚。",
    tip: "试：深夜回应 · 合同纠纷 · 剪辑争议",
    chips: ["事件关键词", "争议名", "热搜话题", "处理结果"],
  },
  {
    key: "time",
    icon: "ri-time-line",
    title: "按时间找",
    lead: "不知道叫什么、只记得大概时间？按月份与热度区间回看，回溯某段时期的黑料目录与热度走势。",
    tip: "试：2024 跨年档 · 年度复盘",
    chips: ["月份区间", "年度榜单", "热度曲线", "周期事件"],
  },
];

export const FEATURE_TABS = ["全部", "人物", "事件", "直播", "综艺"];

export const FEATURES_BIG = [
  {
    tag: "年度复盘",
    tagTone: "primary",
    title: "2024 年度争议时间线 · 从爆料到反转的完整复盘",
    summary:
      "把全年最具代表性的争议事件按月份串成一条时间线，从原始爆料、当事人回应到官方口径，归档每一处关键节点，助你快速掌握来龙去脉。",
    meta: ["档案 · 全篇约 4.2k 字", "更新于 12-31", "热度 120 万"],
    image:
      "https://readdy.ai/api/search-image?query=overhead%20flat%20lay%20of%20a%20timeline%20archive%20spread%20on%20warm%20ivory%20paper%20red%20and%20amber%20threads%20connecting%20tagged%20index%20cards%20with%20month%20stamps%20editorial%20documentary%20style%20soft%20even%20light%20moody%20warm%20tones%20high%20detail%20no%20text%20no%20faces&width=900&height=560&seq=kanliao-feature-big-01&orientation=landscape",
  },
  {
    tag: "深度调查",
    tagTone: "secondary",
    title: "那些年被误读的「实锤」：吃瓜需要一双会鉴瓜的眼睛",
    summary:
      "并非每一条黑料都经得起推敲。本篇从取证逻辑出发，拆解聊天记录、录音与同款线索在证据链里的分量，帮你在看料站检索时少走弯路。",
    meta: ["科普 · 约 3.1k 字", "更新于 12-18", "热度 68 万"],
    image:
      "https://readdy.ai/api/search-image?query=desk%20scene%20of%20evidence%20review%20magnifying%20glass%20over%20stacked%20index%20cards%20phone%20screen%20and%20paper%20notes%20warm%20desk%20lamp%20glow%20ivory%20and%20charcoal%20palette%20editorial%20flat%20lay%20moody%20cinematic%20light%20no%20faces%20no%20text&width=900&height=560&seq=kanliao-feature-big-02&orientation=landscape",
  },
];

export const FEATURES_SMALL = [
  {
    tag: "人物",
    title: "某选秀新人「人设崩塌」全过程",
    heat: "52 万",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20abstract%20portrait%20of%20a%20silhouette%20turning%20away%20dramatic%20chiaroscuro%20lighting%20split%20by%20vermilion%20and%20charcoal%20gradient%20behind%20cinematic%20editorial%20style%20warm%20tone%20no%20recognizable%20face%20no%20text&width=560&height=400&seq=kanliao-feature-sm-01&orientation=squarish",
  },
  {
    tag: "直播",
    title: "顶流主播「嘴瓢翻车」切片合集",
    heat: "61 万",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20live%20stream%20stage%20glare%20in%20blur%20warm%20red%20and%20amber%20neon%20lights%20bleeding%20into%20dark%20background%20cinematic%20editorial%20mood%20no%20faces%20no%20text&width=560&height=400&seq=kanliao-feature-sm-02&orientation=squarish",
  },
  {
    tag: "综艺",
    title: "节目组「恶意剪辑」争议始末",
    heat: "44 万",
    image:
      "https://readdy.ai/api/search-image?query=editing%20timeline%20clips%20arranged%20on%20dark%20desk%20with%20warm%20red%20marker%20highlights%20paper%20storyboards%20scissors%20cinematic%20flat%20lay%20editorial%20warm%20light%20no%20faces%20no%20text&width=560&height=400&seq=kanliao-feature-sm-03&orientation=squarish",
  },
];

export const PEOPLE = [
  {
    field: "内娱 · 顶流圈",
    count: 218,
    active: 86,
    tags: ["官宣", "行程", "同款"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20concert%20stage%20crowd%20silhouettes%20backlit%20in%20warm%20vermilion%20and%20gold%20light%20bokeh%20cinematic%20editorial%20no%20recognizable%20faces%20no%20text&width=320&height=320&seq=kanliao-people-01&orientation=squarish",
  },
  {
    field: "网红 · 短剧圈",
    count: 146,
    active: 63,
    tags: ["合同", "翻车", "人设"],
    image:
      "https://readdy.ai/api/search-image?query=film%20clapperboard%20and%20script%20pages%20on%20warm%20ivory%20background%20with%20amber%20accent%20lights%20cinematic%20editorial%20flat%20lay%20no%20faces%20no%20text&width=320&height=320&seq=kanliao-people-02&orientation=squarish",
  },
  {
    field: "主播 · 带货圈",
    count: 129,
    active: 71,
    tags: ["回应", "切片", "售后"],
    image:
      "https://readdy.ai/api/search-image?query=product%20boxes%20and%20inbox%20tags%20on%20dark%20charcoal%20desk%20with%20warm%20amber%20spotlight%20from%20above%20editorial%20still%20life%20no%20faces%20no%20text&width=320&height=320&seq=kanliao-people-03&orientation=squarish",
  },
  {
    field: "综艺 · 常驻圈",
    count: 92,
    active: 40,
    tags: ["剪辑", "剧本", "退赛"],
    image:
      "https://readdy.ai/api/search-image?query=studio%20monitor%20screens%20glowing%20with%20warm%20gradients%20stacked%20in%20a%20dark%20control%20room%20cinematic%20editorial%20amber%20and%20charcoal%20no%20faces%20no%20text&width=320&height=320&seq=kanliao-people-04&orientation=squarish",
  },
];